import * as yup from 'yup';
import { treasuryRedemptionFormFields } from '../../fields/formFields/treasuryRedemption';
import { amountSchema } from '../common/amountSchema';

export const treasuryRedemptionSchema = yup.object({
  [treasuryRedemptionFormFields.portfolioId]: yup
    .number()
    .typeError('Pick a treasury portfolio')
    .required('Pick a treasury portfolio'),
  [treasuryRedemptionFormFields.type]: yup.string().oneOf(['PARTIAL', 'FULL']).required(),
  // FULL sells everything — no amount.
  [treasuryRedemptionFormFields.amount]: yup.mixed().when(treasuryRedemptionFormFields.type, {
    is: 'PARTIAL',
    then: () => amountSchema,
    otherwise: (schema) => schema.notRequired(),
  }),
  [treasuryRedemptionFormFields.reason]: yup.string().trim().max(1000, 'Reason must be at most 1000 characters'),
});
